/**
 * @packageDocumentation
 * @module f1/to
 */

import { t_bounds } from '../types';

export interface ToBounds {
  /**
   * Force a number to be inside of an array index
   *
   * @public
   * @function f1.to.bounds
   * @param bounds a range to bound the index
   * @param value any value
   * @example
   *
   * ```ts
   * f1.to.bounds([0, 3], 1) => 1
   * f1.to.bounds([0, 3], 0) => 0
   * f1.to.bounds([0, 3], -2) => 0
   * f1.to.bounds([0, 3], 3) => 2
   * f1.to.bounds([0, 3], 4) => 2
   * ```
   */
  (bounds: t_bounds, value: number): number;
  (bounds: t_bounds): (value: number) => number;
}

/**
 * @see ToBounds
 */
export default (bounds: t_bounds, v: number): number => {
  return Math.max(bounds[0], Math.min(bounds[1] - 1, v));
};
